import { useState } from 'react';

type Params = {
  applicationId: string;
  onSuccess: () => void;
};

export const useViewTextScreeningAnswer = ({
  applicationId: _applicationId,
  onSuccess
}: Params) => {
  const [isAnswerViewed, setAnswerViewed] = useState(false);

  const onViewTextScreeningAnswerPress = () => {
    setAnswerViewed(true);
    onSuccess();
  };

  return {
    onViewTextScreeningAnswerPress,
    errorMessage: '',
    isAnswerViewed
  };
};
